// extracted by mini-css-extract-plugin
export default {"blog__container":"Blogs_blog__container__Y7Aki","blog__title":"Blogs_blog__title__wA14X"};